import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { SearchingIcon } from 'LegacyWeployDesignLanguage/icons';

import EmptyState from 'WeployDesignLanguage/EmptyState';

import { BaseProfileCardContainer } from './WeployeeSummarySkeleton';

const StyledEmptyStateCardDetails = styled.div`
  text-align: center;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  & * {
    box-sizing: unset;
  }
`;

const StyledEmptyStateWrapper = styled.div`
  margin-top: ${props => props.theme.spacing[2]};
`;

export const DashedCard = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
  margin: 0;
  position: relative;
  padding: ${props => props.theme.spacing[2]};

  text-align: center;
  background-image:
    linear-gradient(
      to right,
      rgba(0, 0, 0, 0.12) 50%, transparent 50%
    ),
    linear-gradient(
      to right,
      rgba(0, 0, 0, 0.12) 50%,
      transparent 50%
    ),
    linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.12) 50%,
      transparent 50%
    ),
    linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.12) 50%,
      transparent 50%
    );
  background-position: left top, left bottom, left top, right top;
  background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;
  background-size: 20px 1px, 20px 1px, 1px 20px, 1px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
`;

const EmptyStateProfileSummary = ({ description }) => (
  <BaseProfileCardContainer>
    <DashedCard>
      <StyledEmptyStateCardDetails>
        <SearchingIcon />
        <StyledEmptyStateWrapper>
          <EmptyState
            title={description}
          />
        </StyledEmptyStateWrapper>
      </StyledEmptyStateCardDetails>
    </DashedCard>
  </BaseProfileCardContainer>
);

EmptyStateProfileSummary.propTypes = {
  description: PropTypes.string.isRequired,
};

export default EmptyStateProfileSummary;
